"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.background"));

var _Utils = require("./helpers/Utils.js");

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CellContent = function CellContent(props) {
  var type = props.type,
      header = props.header,
      headerText = props.headerText,
      width = props.width,
      sortable = props.sortable,
      sortOrder = props.sortOrder,
      Link = props.Link,
      withImage = props.withImage;
  var _props$data = props.data,
      unit_name = _props$data.unit_name,
      title = _props$data.title,
      name = _props$data.name,
      campaign_name = _props$data.campaign_name,
      date = _props$data.date,
      unit_id = _props$data.unit_id,
      survey_id = _props$data.survey_id,
      bg_color = _props$data.bg_color,
      campaign_id = _props$data.campaign_id,
      image_url = _props$data.image_url,
      img_url = _props$data.img_url,
      surveyless = _props$data.surveyless,
      public_id = _props$data.public_id;
  var unitName = unit_name || name || title;
  var imageUrl = image_url || img_url;

  if (!header && !(0, _Utils.validateString)(unitName) && !(0, _Utils.validateString)(campaign_name) && !(0, _Utils.validateDate)(date)) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
      width: width
    }, "-");
  }

  var headerContent = headerText || type;
  var unitId = unit_id || survey_id || public_id;
  var image = null;

  if (imageUrl) {
    image = /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], {
      url: imageUrl,
      opacity: "0"
    });
  } else if (surveyless) {
    image = /*#__PURE__*/_react["default"].createElement(_styled.InvisibleUnitImage, null);
  } else if (bg_color) {
    image = /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], {
      color: bg_color,
      opacity: "0.3"
    });
  }

  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    type: "content",
    width: width,
    sortable: sortable,
    sortOrder: sortOrder
  }, headerContent) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    padding: "0",
    width: width,
    height: "100%"
  }, withImage ? /*#__PURE__*/_react["default"].createElement(_styled.StyledCellImage, null, image) : null, /*#__PURE__*/_react["default"].createElement(_styled.StyledCellTextContainer, {
    withImage: withImage
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    className: "contentName",
    to: "/measurement/dashboard/".concat(unitId)
  }, unitName), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    color: "lightGrey"
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    className: "campaign",
    to: "/measurement/folders/".concat(campaign_id)
  }, campaign_name))));
};

var _default = CellContent;
exports["default"] = _default;

//# sourceMappingURL=CellContent.js.map